export default {
    listMedia: {
        method: 'get',
        url:'medias'
    },
    listAdzone: {
        method: 'get',
        url:'adzones'
    },
    getAccount: {
        method: 'get',
        url: 'account'
    },
    getTableReport: {
        method: 'post',
        url: 'tableReport'
    },
    getChartReport: {
        method: 'post',
        url: 'chartReport'
    },
    getReportConfig: {
        method: 'get',
        url: 'reportConfig'
    },
    changePwd: {
        method: 'get',
        url: 'changePwd'
    },
    getAdzoneConfig: {
        method: 'get',
        url: 'adzone/config'
    },
    editAdzone: {
        method: 'post',
        url: 'adzone/edit'
    },
    switchAdzone: {
        method: 'post',
        url: 'adzone/switch'
    },
    listInstalledListCallback: {
        method: 'get',
        url: 'installedListCallback'
    },
    getPackageName: {
        method: 'get',
        url: 'packageName'
    },
    createPackageName: {
        method: 'post',
        url: 'packageName/create'
    },
    editPackageName: {
        method: 'post',
        url: 'packageName/edit'
    },
    batchCreatePackageName: {
        method: 'post',
        url: 'packageName/batchCreate'
    },
    setAllCallback: {
        method: 'post',
        url: 'installedListCallback/setAllCallback'
    },
    getAccountAppPackageDetails: {
        method: 'get',
        url: 'accountAppPackageDetails'
    },
    isFullFeedback: {
        method: 'get',
        url: 'isFullFeedback'
    },
    listDeviceTargetingConfig: {
        method: 'get',
        url: 'deviceTargetingConfig'
    },
    createDeviceTargetingConfig: {
        method: 'post',
        url: 'deviceTargetingConfig/create'
    },
    editDeviceTargetingConfig: {
        method: 'post',
        url: 'deviceTargetingConfig/edit'
    },
    deleteDeviceTargetingConfig: {
        method: 'post',
        url: 'deviceTargetingConfig/delete'
    },
    switchDeviceTargetingConfig: {
      method: 'post',
      url: 'deviceTargetingConfig/switch'
    }
}
